import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from "./Login.module.css";
import { Email, Lock } from "../../Svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { getProfile } from '../../redux/userSlice';
import { useDispatch } from 'react-redux';

const Login = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch();

    useEffect(() => {
        const reason = sessionStorage.getItem("logoutReason");
        if (reason === "passwordChanged") {
            toast.warning("You have been logged out because your password was changed on another device. Please log in again.");
            sessionStorage.removeItem("logoutReason");
        }
    }, []);

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    // Formik form handling
    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Email is required'),
            password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required')
        }),
        onSubmit: async values => {
            try {
                const response = await api.login(values);
                if (response.data) {
                    toast.success(response.data?.data?.message)
                    localStorage.setItem("token", response.data?.data?.token);
                    dispatch(getProfile());
                }
            } catch (err) {
                console.log('Login Error', err);
                toast.error(err?.response?.data?.message || 'something went wrong')
            }
        }
    });

    return (
        <div className={styles.logincontainer}>
            <div className={styles.loginimageSection}>
                <div className={styles.imageOverlayText}>
                    <h2>ELECTROWIZ</h2>
                    <p>The Complete Enterprise Platform for Electronic Component Distribution & Supply Chain Management.</p>
                </div>
            </div>
            <div className={styles.loginformSection}>
                <div className={styles.blob1}></div>
                <div className={styles.blob2}></div>
                <div className={styles.loginFormCard}>
                    <div className={styles.loginwelcomeText}>
                        <div className={styles.loginlogo}>
                            <span className={styles.logoIcon}>⚡</span>
                            <span className={styles.logoText}>ELECTROWIZ</span>
                        </div>
                        <h1>Hi, Welcome Back!</h1>
                        <p>Login to your account to enjoy</p>
                    </div>
                    <form onSubmit={formik.handleSubmit} className={styles.loginformMain}>
                        <label>Email address</label>
                        <div className={styles.logininputContainer}>
                            <Email />
                            <input
                                type="email"
                                name="email"
                                placeholder="john@example.com"
                                className={styles.logininputField}
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </div>
                        {formik.touched.email && formik.errors.email ? (
                            <div className={styles.error}>{formik.errors.email}</div>
                        ) : null}

                        <label>Password</label>
                        <div className={styles.logininputContainer}>
                            <Lock />
                            <input
                                type={passwordVisible ? "text" : "password"}
                                name="password"
                                placeholder="********"
                                className={styles.logininputField}
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <FontAwesomeIcon
                                icon={passwordVisible ? faEyeSlash : faEye}
                                className={styles.loginpasswordIcon}
                                onClick={togglePasswordVisibility}
                            />
                        </div>
                        {formik.touched.password && formik.errors.password ? (
                            <div className={styles.error}>{formik.errors.password}</div>
                        ) : null}

                        <div className={styles.loginoptions}>
                             <p className={styles.loginforgotPassword} onClick={() => navigate('/forgot')} style={{ cursor: 'pointer' }}>Forgot your password?</p>
                        </div>

                        <button type="submit" className={styles.loginButton} disabled={formik.isSubmitting}>
                            {formik.isSubmitting ? 'Please wait...' : 'Log In'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
